<template>
  <!-- 舆情扣分详情 -->
  <div class="deduct_detail">
    <div class="head">
      <div class="head_left">
        <div class="head_title">{{ negativeDesc.opinionTitle }}</div>
        <div class="tags">
          <span>{{ negativeDesc.areaName }}</span>
          <!-- <span>{{negativeDesc.areaType === 1 ? '一类地区' : '二类地区'}}</span> -->
        </div>
        <div class="time">{{ negativeDesc.year + '年第' + negativeDesc.quarter + '季度' }}</div>
      </div>
      <div class="head_right">
        <!--  :class="{'line_through': accidentScore == '10.00' && negativeDesc.audited == 1}" -->
        <div v-if="negativeDesc.audited == 1 && accidentScore" class="deduct_score" :class="{ 'line_through': isExceed == '1' && negativeDesc.audited == 1 }">
          -{{ accidentScore }}</div>
        <div v-else class="deduct_score" > 未扣分</div>
        <div v-if="isExceed == '1' && negativeDesc.audited == 1" class="status">已达扣分上限</div>
      </div>
    </div>
    <div class="content">
      <div class="happend_time">
        <div class="tit ">考评信息</div>
        <div class="desc flex flex-row justify-between">
          <div class="flex-none">扣分原因：</div>
          <div class="flex-1 text-start">{{ negativeDesc.deductionReason }}</div>
        </div>
        <div class="desc" v-if="negativeDesc.audited == 1">审核时间：{{ negativeDesc.auditTime }}</div>
      </div>
      <div class="happend_time">
        <div class="tit">舆情概况</div>
        <div class="desc flex flex-row justify-between">
          <div class="flex-none ">舆情标题：</div>
          <div class="flex-1 text-start">{{ negativeDesc.opinionTitle }}</div>
        </div>
        <div class="desc">舆情级别：{{ opinionLevel }}</div>
        <div class="desc">信息来源：{{ infoSource }}</div>
        <div class="desc">发布日期：{{ issuanceTime }}</div>
        <div class="desc">涉及州市：{{ multiAreaData }}</div>
        <div class="desc">问题分类：{{ opinionType }}</div>
        <div class="desc">信息来源：{{ infoSource }}</div>

        
        <div v-show="!showMore">
          <div class="more_cont">信息链接：</div>
          <div class="desc link desc_line" @click="openUrl(infoUrl)">{{ infoUrl }}</div>
          <div class="more_cont">网络走势：</div>
          <div class="desc desc_line">{{ negativeDesc.netTend }}</div>
          <div class="more_cont">主要内容：</div>
          <div class="desc desc_line">{{ negativeDesc.opinionDesc }}</div>
         
        </div>
        <div class="deal_desc">
          <div class="open_more">
            <span v-show="showMore" @click="openMore">展开</span>
            <span v-show="!showMore" @click="openMore">收起</span>
            <i v-show="showMore" class="drop_down"></i>
            <i v-show="!showMore" class="drop_up"></i>
          </div>
        </div>
      </div>
      <div class="related_file">
        <div class="file_title">相关材料</div>
        <div class="file_item" v-for="item in fileResVOS" :key="item.id">
          <div class="file_msg" @click="openFile(item)">
            <img v-if="item.fileType === 'exl'" src="@/assets/appraise/ic_exl.png" alt />
            <img v-if="item.fileType === 'doc'" src="@/assets/appraise/ic_doc.png" alt />
            <img v-if="item.fileType === 'pdf'" src="@/assets/appraise/ic_pdf.png" alt />
            <p class="file_name">
              <span>{{ item.fileName }}{{ '.' + item.fileType }}</span>
            </p>
          </div>
          <div class="file_size">{{ item.fileSize }}</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="negativeDesc.audited === 0" class="bot_btn">
      <btnauth custype="apply" :year="year" :quarter="quarter">
        <div class="opreate">
          <div class="delete_btn" @click="deleteSituation" v-if=" deleteAuth === 'OPERATION03' ">
            <img src="@/assets/appraise/delete.png" alt />
            <span class>删除</span>
          </div>
          <div class="edit_btn" @click="editSituation" v-if=" updateAuth === 'OPERATION02' ">
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>
        </div>
      </btnauth>
      <btnauth custype="audit" :year="year" :quarter="quarter">
        <div class="check_btn" v-if=" userAuthoirese === 'OPERATION06' ">
          <van-button @click="check" type="primary">审核</van-button>
        </div>
      </btnauth>
    </div> -->
    <!-- <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <modalIframe :url="iframeurl"></modalIframe> -->
  </div>
</template>

<script>
import titleDialog from "../components/titleDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import btnauth from "../appraiseNew/components/btnauth";
import modalIframe from "../appraiseNew/components/modalIframe";
export default {
  components: {
    titleDialog,
    btnauth,
    modalIframe
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: "",
      cancelBtn: "",
      confirmBtn: "",
      showMore: true,
      oprate_dom: true,
      fileResVOS: [],
      opinionLevel: "",
      opinionType: "",
      netTend: "",
      infoUrl: "",
      infoSource: "",
      multiAreaData: "",
      issuanceTime: "",
      accidentScore: 0,
      surplusScore: 10,
      negativeDesc: {},
      cityList: [],
      newQuarterList: [
        { id: "one", text: "一级负面舆情" },
        { id: "two", text: "二级负面舆情" },
        { id: "three", text: "三级负面舆情" },
        { id: "normal", text: "一般负面舆情" }
      ],
      //权限字段
      // 3个操作权限
      userAuthoirese: this.$route.query.userAuthoirese,
      updateAuth: this.$route.query.updateAuth,
      deleteAuth: this.$route.query.deleteAuth,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      iframeurl: "",
      isExceed: this.$route.query.isExceed
    };
  },
  created() {
    this.queryDetail();
  },
  updated() {
    this.$nextTick(() => {
      if (this.negativeDesc.opinionDesc && this.negativeDesc.opinionDesc.length < 120) {
        this.oprate_dom = false;
      }
    });
  },
  methods: {
    // 审核
    check() {
      const { year, quarter, area } = this.$route.query;
      this.$router.push(
        `/appraise/checkNegative?id=${this.$route.query.id}&area=${area}&year=${year}&quarter=${quarter}`
      );
    },
    // 删除情况
    deleteSituation() {
      (this.dialogTitle = "是否确定删除"),
        (this.cancelBtn = "取消"),
        (this.confirmBtn = "删除"),
        (this.showDialog = true);
    },
    // 链接跳转
    openUrl(url) {
      // window.location.href =  url;
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: url,
          isFullScreen: 0,
          setTitle: "",
          needLoading: 1
        },
        cb => {
          console.log(cb, "callback");
        }
      );
    },
    // 查询详情
    queryDetail() {
      let params = {
        id: this.$route.query.id
      };
      api.getOpinionDetail(params).then(res => {
        if (res.ret === 0) {
          this.negativeDesc = res.data.detailResVOS[0];
          this.cityList = res.data.detailResVOS;
          this.fileResVOS = res.data.fileResVOS;
          this.opinionLevel = this.newQuarterList.filter(item => {
            return item.id === res.data.detailResVOS[0].opinionLevel;
          })[0].text;
          const {
            opinionType,
            infoSource,
            issuanceTime,
            netTend,
            multiAreaData,
            infoUrl
          } = res.data.detailResVOS[0];
          this.opinionType = opinionType;
          this.infoSource = infoSource;
          this.issuanceTime = issuanceTime;
          this.netTend = netTend;
          this.multiAreaData = multiAreaData;
          this.infoUrl = infoUrl;
          this.accidentScore = (this.negativeDesc.deduction / 10000).toFixed(2);
          this.surplusScore = (
            (1000 - this.negativeDesc.deduction) /
            10000
          ).toFixed(1);
        }
      });
    },
    // 编辑
    editSituation() {
      // let data = {
      //   fileResVOS: this.fileResVOS,
      //   infoSource: this.negativeDesc.infoSource,
      //   infoUrl: this.negativeDesc.infoUrl,
      //   issuanceTime: this.negativeDesc.issuanceTime,
      //   netTend: this.negativeDesc.netTend,
      //   opinionDesc:  this.negativeDesc.opinionDesc,
      //   opinionLevel: this.negativeDesc.opinionLevel,
      //   opinionTitle: this.negativeDesc.opinionTitle,
      //   opinionType: this.negativeDesc.opinionType,
      //   cityList: this.cityList
      // }
      const { year, quarter, area } = this.$route.query;
      let negativeSummary = {
        opinionTitle: this.negativeDesc.opinionTitle,
        opinionType: this.negativeDesc.opinionType,
        opinionLevel: this.negativeDesc.opinionLevel
      };
      this.$store.commit("appraise/setNegativeSummary", negativeSummary);
      let negativeDesc = {
        opinionDesc: this.negativeDesc.opinionDesc,
        infoSource: this.negativeDesc.infoSource,
        issuanceTime: this.negativeDesc.issuanceTime,
        netTend: this.negativeDesc.netTend,
        infoUrl: this.negativeDesc.infoUrl,
        fileResVOS: this.fileResVOS
      };
      this.$store.commit("appraise/setNegativeDesc", negativeDesc);
      let negativeCitys = {
        cityList: this.cityList
      };
      this.$store.commit("appraise/setNegativeCitys", negativeCitys);
      this.$router.push(
        `/appraise/addNegative?id=${this.$route.query.id}&year=${year}&quarter=${quarter}&area=${area}`
      );
    },
    /**
     * @description: 打开附件
     * @param { item } object
     */
    openFile(item) {
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓进来这里url:", item.fileUrl);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        this.iframeurl = item.fileUrl;
        // this.$router.push({ path: "/appraise/iframepdf", query: { url: item.fileUrl } });
      } else {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: item.fileUrl,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      }
      setTimeout(() => {
        _this.iframeurl = "";
      }, 100);
      // window.yyn.invokeJSB(
      //   "openWindow",
      //   {
      //     openUrl: item.fileUrl,
      //     isFullScreen: 0,
      //     setTitle: item.fileName,
      //     needLoading: 1
      //   },
      //   cb => {
      //     console.log(cb, "callback");
      //   }
      // );
    },
    openMore() {
      this.showMore = !this.showMore;
    },
    // 删除舆情
    deleteNegative() {
      const { year, quarter, area } = this.$route.query;
      let params = {
        id: this.$route.query.id
      };
      api.badOpinionDel(params).then(res => {
        if (res.ret === 0) {
          this.$Toast({
            message: "删除成功",
            icon
          });
          setTimeout(() => {
            // this.$router.replace(
            //   `/appraise/negativeList?area=${area}&year=${year}&quarter=${quarter}`
            // );
            this.$router.back(-1);
          }, 2000);
        }
      });
    },
    // 弹窗确认回调
    confirm() {
      this.showDialog = false;
      this.deleteNegative();
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style scoped lang="less">
.deduct_detail {
  padding-bottom: 60px;

  .head {
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    width: 100%;
    // height: 110px;
    border-bottom: 1px solid #eee;
  }

  .head_left {
    padding-bottom: 16px;

    .head_title {
      margin: 24px 0 12px;
      color: #333;
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
    }

    .tags span {
      display: inline-block;
      margin-right: 9px;
      padding: 1px 4px;
      font-size: 10px;
      line-height: 14px;
      color: #36b374;
      border: 1px solid #36b374;
    }

    .time {
      margin-top: 12px;
      font-size: 12px;
      color: #999;
    }
  }

  .head_right {
    // padding-top: 22px;
    text-align: right;
    margin-top: 27px;

    .deduct_score {
      font-size: 22px;
      font-weight: 500;
      text-align: right;
      color: #ff4d4d;
    }

    .percent {
      margin: 8px 0 16px;
      color: #999;
      font-size: 14px;
      font-weight: 500;
    }

    .status {
      display: inline-block;
      margin-top: 9px;
      margin-left: 6px;
      width: 85px;
      font-size: 14px;
      color: #ff8c19;
      text-align: right;
    }
  }

  .content {

    .deduct_reason,
    .happend_time {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      color: #333;

      .tit {
        padding: 15px 0 14px;
        font-size: 16px;
        font-weight: bold;
      }

      .desc {
        padding-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
      }

      .desc:last-child {
        padding-bottom: 16px;
      }
    }

    .deal_desc {
      position: relative;
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      color: #333;

      .tit {
        padding: 15px 0 14px;
        font-size: 16px;
        font-weight: bold;
      }

      .desc {
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
      }

      .more_cont {
        padding-bottom: 0px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
      }

      .open_more {
        padding-bottom: 16px;
        text-align: left;

        span {
          margin-right: 5px;
          font-size: 14px;
          color: #666;
        }

        .drop_down {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-bottom-color: transparent;
        }

        .drop_up {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }
  }

  .related_file {
    padding: 0 12px;

    .file_title {
      padding: 15px 0 16px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .file_item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;

      .file_msg {
        flex: 1;
        display: flex;
        align-items: center;
      }

      .file_msg img {
        margin-right: 12px;
        width: 34px;
        height: 38px;
      }

      .file_msg p {
        font-size: 14px;
        color: #333;

        span {
          line-height: 20px;
          word-break: break-word;
        }
      }

      .file_size {
        font-size: 12px;
        color: #999;
      }

      .delImg {
        box-sizing: border-box;
        line-height: 38px;
        margin-left: 5px;
        margin-right: 10px;
      }

      .delImg img {
        width: 15px;
        height: 16px;
      }
    }
  }

  .bot_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);

    .opreate {
      padding: 12px 0;

      div {
        display: inline-block;
      }
    }

    .delete_btn {
      margin-right: 24px;
    }

    img {
      display: inline-block;
      margin-right: 4px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }

    span {
      display: inline-block;
      font-size: 16px;
      color: #36b374;
      vertical-align: middle;
    }
  }

  .check_btn .van-button {
    width: 203px;
    height: 40px;
    border-radius: 3px;
    background-color: #36b374;

    span {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.more_desc {
  margin-bottom: 10px;
  padding-bottom: 0 !important;
  display: inline-block;
}

// .show_more {
//   max-height: 140px;
//   overflow: hidden;
// }
.drop_down {
  display: inline-block;
  width: 0;
  height: 0;
  border: 4px solid #9b9b9b;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}

.drop_up {
  display: inline-block;
  width: 0;
  height: 0;
  border: 4px solid #9b9b9b;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
}

.line_through {
  text-decoration: line-through;
}

.link {
  // color: #00e;
  color: #36b374;
}

.desc_line {
  word-wrap: break-word
}
</style>